/**
 * ? @description : SPOC : Trainer Profiles Component
 */

// Dependencies
import React, { Fragment, useState, useEffect } from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { Box, Chip, CircularProgress } from "@mui/material";

// Modals
import TrainerData from "./modals/TrainerData";

// Axios Component
import Axios from "../../../../../axios/Axios";
import axios from "axios";

function TrainerProfiles() {

  // const dispatch = useDispatch();
  const spoc_id = sessionStorage.getItem("user_id"); 
  // * State Variables
  const [teachersData, setTeachersData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [teacherModal, setTeacherModal] = useState(false);
  const [isDataFetchError, setIsDataFetchError] = useState(false);

 // for pagination state 
 const [rowsPerPage, setRowsPerPage] = useState(5);
 const handleRowsPerPageChange = (newRowsPerPage) => {
   setRowsPerPage(newRowsPerPage);
 };
  // * Fetching Data
  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      try {
        const options = {
          method: "get",
          url: `teacher/get/spoc/teacherdetails/${spoc_id}`,
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };
  
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
        
        let teacherTrainingList = response.data.flatMap(num => num);
        teacherTrainingList.length !== 0 ? setTeachersData(teacherTrainingList) : setIsDataFetchError(true);
  
      } catch (error) {
        if(!axios.isCancel(error)) {
          setIsDataFetchError(true)
          console.log(error);
        }
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [spoc_id,rowsPerPage ]);

  // * Column Declarations
  const columns = [
    {
      name: "teacher_id",
      label: "Teacher Id",
      options: {
        display:false,
        filter: true,
        filterType: "Dropdown",
        sort: true,
        sortDirection: "desc",
        download: true,
      },
    },
    {
      name: "teacher_name",
      label: "Teacher Name",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
        // customBodyRender: (value) => {
        //   return (
        //     <div>
        //       <Chip
        //         label={value}
        //         color="primary"
        //         size="small"
        //         clickable
        //         onClick={() => setTeacherModal(true)}
        //       />
        //     </div>
        //   );
        // },
      },
    },
    // {
    //   name: "group_id",
    //   label: "Batch Id",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    // {
    //   name: "group_name",
    //   label: "Batch Name",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    {
      name: "audio_status",
      label: "Audio Status",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
      },
    },
    // {
    //   name: "training_video_status",
    //   label: "Training Video Status",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    {
      name: "attendance_status",
      label: "Attendance Status",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
      },
    },
    // {
    //   name: "video_viewed_time",
    //   label: "Video Viewed Time",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    {
      name: "role",
      label: "Role",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
      },
    },
    // {
    //   name: "date_of_promotions",
    //   label: "Date of Promotions",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     download: true,
    //   },
    // },
    {
      name: "tcreated_at",
      label: "Registered Date",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
        customBodyRender: (value) => {
          return <div>{value.slice(0, 10)}</div>;
        },
      },
    },
    {
      name: "batch_member_id",
      label: "Batch Member Id",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        download: true,
        display: false,
      },
    },
  ];

  // * Options for the Table Configuration
  const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
      }
    },
    filter: true,
    filterType: "dropdown",
    responsive: "stacked",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    onChangeRowsPerPage: handleRowsPerPageChange ,
    jumpToPage: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    onRowClick: (rowData) => {
      setSelectedRowData(rowData);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach(col => {
        if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
        }
      });
    }
  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };
 
  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  return (
    <Fragment>
      {/* Table */}
      <Box>
        <MUIDataTable
          title ={`Teachers Training Data (${teachersData.length})`}
          data={teachersData}
          columns={columns}
          options={options}
          components={{ TableFilterList: CustomFilterList }}
        />
      </Box>

      {/* Modal */}
      <TrainerData
        open={teacherModal}
        onClose={() => setTeacherModal(false)}
        selecteddata={selectedRowData}
      />
    </Fragment>
  );
}

export default TrainerProfiles;
